module.exports = __webpack_public_path__ + "img/accessory_item_16.9d188fc8.svg";